import { useEffect, useRef, useState } from "react";
import $ from "jquery";
import { LenguageTabla } from "../../../Comunes/LenguajeTabla/LenguajeTabla";
import AgregarArchivoModal from "./AgregarArchivoModal";
import { __DescargarArchivo } from "../../../../Utils/Funciones";
import { CerrarNotificador, Notificar } from "../../../Comunes/Notificador";
import servicioCambiosCic from "../../../../servicios/servicioCambiosCic";

function DocumentosSolicitudCambioCic({
  documentos = [],
  actualizarDocumentos = null,
  permiteAgregar = false,
  permiteEliminar = false,
  permiteDescargar = false,
}) {
  const [archivos, setArchivos] = useState(documentos);
  const tableRef = useRef();

  const DescargarDocumento = async (documento) => {
    CerrarNotificador();

    let resultado = await servicioCambiosCic.ObtengaArchivoSolicitudCambioCic(
      documento
    );
    if (!resultado.archivo) {
      Notificar(
        "error",
        "Ha ocurrido un error intentando obtener el documento"
      );
    }

    __DescargarArchivo(resultado.archivo, resultado.nombreArchivo);
  };

  useEffect(() => {
    const tabla = $(tableRef.current).DataTable({
      language: {
        ...LenguageTabla,
        emptyTable: "No se han agregado archivos",
      },
      processing: true,
      destroy: true,
      paging: false,
      searching: false,
      data: archivos,
      columns: [
        {
          data: "nombreArchivo",
        },
        {
          data: "tipoComplemento.descripcion",
        },
        {
          data: "descripcion",
        },
        {
          data: null,
        },
        {
          data: null,
        },
      ],
      columnDefs: [
        {
          targets: 3,
          defaultContent:
            "<button class='btn btn-primary btn-sm js-descargar'><i class='fas fa-download'> </i></button>",
          searchable: false,
          orderable: false,
          visible: permiteDescargar,
        },
        {
          targets: 4,
          defaultContent:
            "<button class='btn btn-danger btn-sm js-eliminar'><i class='fa fa-trash'></i></button>",
          searchable: false,
          orderable: false,
          visible: permiteEliminar,
        },
      ],
    });

    tabla.off("click");

    tabla.on("click", ".js-eliminar", function () {
      tabla.row($(this).parents("tr")).remove().draw();
      const nuevaLista = tabla.rows().data().toArray();
      actualizarArchivos(nuevaLista);
    });

    tabla.on("click", ".js-descargar", function () {
      const tr = $(this).closest("tr");
      let rowData = tabla.row(tr).data();
      DescargarDocumento(rowData);
    });
  });

  function agregarArchivo(archivo) {
    const nuevaLista = [...archivos, archivo];
    actualizarArchivos(nuevaLista);
  }

  function actualizarArchivos(nuevaLista) {
    setArchivos(nuevaLista);
    actualizarDocumentos(nuevaLista);
  }

  return (
    <div className="card shadow mb-4">
      <div className="card-header">
        <h6 className="m-0 font-weight-bold text-primary">
          Archivos de la Solicitud
        </h6>
      </div>
      <div className="card-body">
        {permiteAgregar ? (
          <AgregarArchivoModal actualizarArchivos={agregarArchivo} />
        ) : null}

        <table
          className="table table-striped table-hover w-auto display"
          ref={tableRef}
        >
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Tipo Complemento</th>
              <th>Descripción</th>
              <th>Descargar</th>
              <th>Eliminar</th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  );
}

export default DocumentosSolicitudCambioCic;
